import { useEffect, useRef } from "react";

// Zone de texte de personnalisation : 3 lignes minimum, et grandit automatiquement
// d'une ligne chaque fois que le client appuie sur « Entrée ».
export default function PersoTextarea({ value, onChange, ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);
  return (
    <textarea
      ref={ref}
      rows={3}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  );
}
